<template>
    <section class="bg-ccu">
        <div class="container">
            <div class="v-h"></div>
            <Moharam  v-if="$store.state.options.moharam" />
            <div class="row">

                <!-- <div class="col-12">
                <div class="apland-timeline-area">
                    <div class="single-timeline-area animate__animated animate__fadeInRight" v-for="(category,index) in $store.state.categories" :key="index" :style="`animation-delay:.${index+5}s`">
                        <div class="timeline-date wow fadeInLeft" data-wow-delay="0.1s" style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInLeft;">
                            <router-link :to="{name:'category','params':{'link':category.link}}" class="font-weight-bold text-dark ">{{category.name}}</router-link>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4 animate__animated animate__fadeIn" v-for="(cate,i) in category.sub_categories" :key="i" :style="`animation-delay:.${i+5}s`">
                                <router-link :to="{name:'category','params':{'link':category.link},query:{sub:encodeParam(cate.id)}}" class="single-timeline-content d-flex " data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInLeft;">
                                    <div  class="timeline-text">
                                        <h6 class="font-weight-bold">{{cate.name}}</h6>
                                     </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div> -->

                <div class="col-12" v-for="(category,index) in $store.state.categories" :key="index"
                    :style="`animation-delay:.${index+5}s`">
                    <div class="card p-0 m-2">
                        <router-link :to="{name:'category','params':{'link':category.link}}" class="card-header d-flex hydratedd">
                            <ion-icon name="folder-outline"></ion-icon>
                            <h5
                                class="font-weight-bold text-dark mx-2"> {{category.name}}</h5>
                        </router-link>
                        <div class="card-body d-flex flex-wrap  justify-content-start" v-if="category.sub_categories.length !=0">
                            <vs-button v-for="(sub,i) in category.sub_categories" :key="i" danger flat
                                :to="{name:'category','params':{'link':category.link},query:{sub:encodeParam(sub.id)}}">
                                {{sub.name}}
                            </vs-button>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Moharam from '../components/moharam.vue'
    export default {
        components:{Moharam},
        methods: {
            encodeParam(text) {
                return btoa(text);
            }
        }
    }
</script>
<style scoped>
    .v-img {
        border-radius: 2px;
        position: relative;
    }

    .v-img .l-1 {
        z-index: 1;
        position: absolute;
        width: 92%;
        left: 4%;
    }

    .v-img .l-2 {
        z-index: 2;
        position: absolute;
        margin-top: 11px;
        width: 96%;
        left: 2%;
    }

    .v-img a {
        display: inline-block;
        position: relative;
        z-index: 3;
        width: 100%;
    }

    .v-img .l-3 {
        z-index: 3;
        margin-top: 22px;
    }

    .v-img img {
        border: solid 1px #ffffff8f;
        width: 100%;
        border-radius: 4px;
        max-height: 170px;
        object-fit: cover;
    }

    .v-img .items {
        position: absolute;
        bottom: 40px;
        right: 15px;
        background-color: #373933;
        border-radius: 2px;
        color: #ffffff;
        font-size: 14px;
        padding: 6px 9px 1px 9px;
        line-height: 1.3;
        font-weight: 500;
        z-index: 5;
    }

    .timeline_area {
        position: relative;
        z-index: 1;
    }

    .single-timeline-area {
        position: relative;
        z-index: 1;
        padding-right: 180px;
    }

    @media only screen and (max-width: 575px) {
        .single-timeline-area {
            padding-right: 100px;
        }
    }

    .single-timeline-area .timeline-date {
        position: absolute;
        width: 180px;
        height: 91%;
        top: 15px;
        right: 0;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -ms-grid-row-align: center;
        align-items: center;
        -webkit-box-pack: end;
        -ms-flex-pack: end;
        justify-content: flex-end;
        padding-left: 60px;
    }

    @media only screen and (max-width: 575px) {
        .single-timeline-area .timeline-date {
            width: 100px;
        }
    }

    .single-timeline-area .timeline-date::after {
        position: absolute;
        width: 3px;
        height: 100%;
        content: "";
        background-color: #d5d5d5;
        top: 0;
        left: 30px;
        z-index: 1;
    }

    .single-timeline-area .timeline-date::before {
        position: absolute;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background-color: #f1c40f;
        content: "";
        top: 50%;
        left: 26px;
        z-index: 5;
        margin-top: -5.5px;
    }

    .single-timeline-area .timeline-date p {
        margin-bottom: 0;
        color: #020710;
        font-size: 16px;
        text-transform: uppercase;
        font-weight: 500;
    }

    .single-timeline-area .single-timeline-content {
        position: relative;
        z-index: 1;
        padding: 30px 30px 25px;
        border-radius: 6px;
        margin-bottom: 15px;
        margin-top: 15px;
        -webkit-box-shadow: 0 0.25rem 1rem 0 rgba(47, 91, 234, 0.125);
        box-shadow: 0 0.25rem 1rem 0 rgba(47, 91, 234, 0.125);
        border: 1px solid #ebebeb;
    }

    @media only screen and (max-width: 575px) {
        .single-timeline-area .single-timeline-content {
            padding: 20px;
        }
    }

    .single-timeline-area .single-timeline-content .timeline-icon {
        -webkit-transition-duration: 500ms;
        transition-duration: 500ms;
        width: 30px;
        height: 30px;
        background-color: #f1c40f;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 30px;
        flex: 0 0 30px;
        text-align: center;
        max-width: 30px;
        border-radius: 50%;
        margin-left: 15px;
    }

    .single-timeline-area .single-timeline-content .timeline-icon i {
        color: #ffffff;
        line-height: 30px;
    }

    .single-timeline-area .single-timeline-content .timeline-text h6 {
        -webkit-transition-duration: 500ms;
        transition-duration: 500ms;
    }

    .single-timeline-area .single-timeline-content .timeline-text p {
        font-size: 13px;
        margin-bottom: 0;
    }

    .single-timeline-area .single-timeline-content:hover .timeline-icon,
    .single-timeline-area .single-timeline-content:focus .timeline-icon {
        background-color: #020710;
    }

    .single-timeline-area .single-timeline-content:hover .timeline-text h6,
    .single-timeline-area .single-timeline-content:focus .timeline-text h6 {
        color: #3f43fd;
    }
</style>